export default [
  'Vendor Name',
  'Receiving Compliance Grade',
  'Grade Updated Date',
].map((value, key) => ({ value, key }));
